export default __webpack_public_path__ + "static/media/d.20034fd0.svg";